import { render } from "./AllTimeArtist.vue?vue&type=template&id=308f78e0"
import script from "./AllTimeArtist.vue?vue&type=script&lang=js"
export * from "./AllTimeArtist.vue?vue&type=script&lang=js"

import "./AllTimeArtist.vue?vue&type=style&index=0&id=308f78e0&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__